import React, { useState } from "react";

import AttendenceOverview from "./AttendenceOverview";
import MerchantBaseOverview from "./MerchantBaseOverview";
import TargetVsAchivement from "./TargetVsAchivement";
import PerformanceOverview from "./PerformanceOverview";
import GeographyFilters from "./GeographyFilters";
import { makeStyles } from "@material-ui/core";
import AcquisitionOverview from "./AcquisitionOverview";

const useStyles = makeStyles(() => ({
  root: {
    padding: 20,
    backgroundColor: "rgba(234, 238, 249, 1)",
    minHeight: "100vh",
  },
}));

export default function RevampedDashboard() {
  const [geoFilters, setGeoFilters] = useState({
    agency: [],
    region: [],
    area: [],
    territory: [],
    clusters: [],
  });
  const classes = useStyles();
  React.useEffect(() => {
    console.log(geoFilters);
  }, [geoFilters]);
  const generateFilters = () => {
    if (geoFilters.agency?.length > 0) {
      return {
        agency: geoFilters.agency,
      };
    } else if (geoFilters.territory?.length > 0) {
      return {
        territory: geoFilters.territory,
      };
    } else if (geoFilters.area?.length > 0) {
      return {
        area: geoFilters.area,
      };
    } else if (geoFilters.region?.length > 0) {
      return {
        region: geoFilters.region,
      };
    } else if (geoFilters.clusters?.length > 0) {
      return {
        clusters: geoFilters.clusters,
      };
    }

    return {};
  };

  return (
    <div className={classes.root}>
      <GeographyFilters {...geoFilters} onFilterChange={setGeoFilters} />
      <TargetVsAchivement {...{ geoFilters: generateFilters() }} />
      <MerchantBaseOverview {...{ geoFilters: generateFilters() }} />
      <PerformanceOverview {...{ geoFilters: generateFilters() }} />
      <AcquisitionOverview {...{ geoFilters: generateFilters() }} />
      <AttendenceOverview {...{ geoFilters }} />
    </div>
  );
}
